// 活动
const HOME = {
  category: { apiUrl: '/category/queryCategoryList', method: 'post' }, // 分类
  desCategory: { apiUrl: '/category/queryCategory', method: 'post' }, // 分类
  address: { apiUrl: '/address/queryAddressList', method: 'post' }, // 地址列表
  searchAddress: { apiUrl: '/address/queryAddressName', method: 'post' } // 搜索地址列表
}
export default HOME
